import { useEffect } from 'react';

import { reportingTreeStore } from '@stores/reportingTreeStore';

// запоминаем состояния страницы между сессиями
export const useSessionStorageConfig = (): void => {
  const { stateTree, setStateTree, organizationCode, setFilters, filters } = reportingTreeStore;

  useEffect(() => {
    const storage = localStorage.getItem('expandedTreeFromAnotherRouter');
    if (storage) return;

    const config = sessionStorage.getItem('reportingTreeConfig');
    const parseConfig = config ? JSON.parse(config) : null;

    if (parseConfig) {
      setFilters(parseConfig.filters ?? {});
      setStateTree(
        parseConfig.stateTree ?? {
          expandedKeys: [],
          searchValue: '',
          autoExpandParent: true,
        },
      );

      sessionStorage.setItem('reportingTreeConfig', JSON.stringify({ organizationCode: parseConfig.organizationCode })); // на всякий случай очищаем состояние tree, чтобы дерево отчетов всегда отображалось в случаи возможной ошибки
    }
  }, [setFilters, setStateTree]);

  useEffect(() => {
    const config = { filters, organizationCode, stateTree };
    if (organizationCode) sessionStorage.setItem('reportingTreeConfig', JSON.stringify(config));
  }, [filters, organizationCode, stateTree]);
};
